import { useBreakpoint } from "@gettactic/helpers/src/hooks/useBreakpoint";
import { ReactNode } from "react";

export interface TableHeaderContentRendererProps {
  children: ReactNode;
}

export const TableHeaderContentRenderer = ({
  children
}: TableHeaderContentRendererProps): JSX.Element => {
  const { isBreakpoint } = useBreakpoint();
  const isMd = isBreakpoint("md");

  return <div className={isMd ? "pr-4" : undefined}>{children}</div>;
};
